//nav-mobile-trigger

var hornstrup = hornstrup || {};
hornstrup.imageOverlayBlendModeNotSupported = hornstrup.imageOverlayBlendModeNotSupported || function () {
    var self = this;

    this.init = function (callback) {
        if(window.getComputedStyle(document.body).mixBlendMode == undefined){
            $('#hero .hero__bg-image, .mosaic-image__image, .list4--auto .list4__figure').prepend('<div class="missing-blend-mode-fix"></div>');
        }
    }

    // public functions:
    return {
        init: init
    };
}();